export const fundAwardLanguage = {
  checkTseMarket: 'برای اعمال کد هدیه، نیاز به پذیرش حوزه اوراق دارید',
  checkTseMarketDescription:
    'اگر قبلا این فرایند را تکمیل و قرارداد را امضا کرده‌اید، نیازی به اقدام مجدد نیست. فرایند پذیرش معمولا ۱ تا ۲ روز کاری زمان می‌برد و نتیجه از طریق پیامک اطلاع‌رسانی می‌شود.',
  checkTseMarketButton: 'ثبت نام',
};
export const clubCheckLanguage = {
  clubCheck: 'برای دریافت هدیه صندوق باید عضو بآشگاه مشتریان اگاه باشید.',
  clubCheckDescription: 'برای دریافت هدیه صندوق باید عضو بآشگاه مشتریان اگاه باشید.',
  clubCheckButton: 'باشگاه مشتریان',
};
export const formLanguage = {
  formPlaceholder: 'کد هدیه خود را وارد کنید.',
  applyButton: 'اعمال',
};

export const fundAward = {
  title: 'هدیه صندوق',
};
